import { QueryClient } from "react-query";
import { subscribeSessionUpdates } from "@/context/auth/sessionRenewal";
import {
  createSentryMutationCache,
  createSentryQueryCache,
} from "./sentryReactQuery";

// One cache for the app; export it so tests exercise the same session wiring.
export const queryClient = new QueryClient({
  queryCache: createSentryQueryCache(),
  mutationCache: createSentryMutationCache(),
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, refetchOnMount: "always" },
  },
});

// Cancel old in-flight queries as well as dropping successful cached data.
// ClientLayout verifies the new user before remounting the operational tree.
subscribeSessionUpdates(() => queryClient.clear());
